import React, { useMemo } from 'react'
import { useLocation } from 'react-router'
import MyWorkQueue from './MyWorkQueue'
import MiscellaneousMyWorkQueue from '../MiscRecords/MiscellaneousMyWorkQueue'

const MyWorkQueueWrapper = (props) => {
  const location = useLocation()
  const { sublinks } = props

  const isMiscRecordsType = useMemo(() => {
    const parts = location.pathname.split('/')
    const sublink = (sublinks || []).find((x) => x.parameter === parts[parts.length - 1])
    return sublink ? !!sublink.IsMiscRecordsType : false
  }, [location, sublinks])

  if (isMiscRecordsType) return <MiscellaneousMyWorkQueue {...props} />
  return <MyWorkQueue {...props} />
}

export default MyWorkQueueWrapper